import { css } from '@emotion/react';

export const videoPlayer = css`
  padding-bottom: 5px;
`;
